import { render, staticRenderFns } from "./pointItemKbnInfo.vue?vue&type=template&id=da75afdc&"
import script from "./pointItemKbnInfo.vue?vue&type=script&lang=js&"
export * from "./pointItemKbnInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports